import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { DialogContent } from "@mui/material";
import { LoadingButton } from "@mui/lab";

export default function ConfirmModal({
	open,
	setOpen,
	title,
	desc,
	loading,
	runFunc,
	action,
	runSecFunc,
	btnfirst,
	btnsecound,
}) {
	return (
		<Dialog
			fullWidth={true}
			maxWidth={"sm"}
			open={open.confirmOpen}
			onClose={() => setOpen({ confirmOpen: false, id: null })}>
			<DialogTitle color={"black"} fontSize={"18px"}>
				{title}
			</DialogTitle>
			{desc && <DialogContent>{desc}</DialogContent>}
			<DialogActions>
				<LoadingButton
					loading={loading}
					variant="contained"
					color="secondary"
					sx={{ ml: 2, color: "white" }}
					onClick={runFunc}>
					{btnfirst ? btnfirst : "تایید"}
				</LoadingButton>
				<Button
					variant="contained"
					color="primary"
					onClick={
						action
							? () => runSecFunc()
							: () => setOpen({ confirmOpen: false, id: null })
					}>
					{btnsecound ? btnsecound : "انصراف"}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
